(function () { 
 return angular.module("ShargoApp")
.constant("Configuration", {"defaultLang":"en","appMode":"production","apiUrl":"https://api.shargo.io","gaTrackingID":"UA-72204457-2","gaDomainName":"shargo.io","updateInterval":10,"siteDomain":"https://old.shargo.io","defaultTimeout":3000,"fbAppId":"1612290799020399","facebookPixelId":"1693703070904924","oneSignalAppId":"9ab1430d-1392-4be1-9f69-560715af368c","oneSignalSafariWebId":"web.com.ShargoFarm.Shargo"});

})();
